export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20organic%20abstract%20texture%20with%20gentle%20gradient%20from%20cream%20to%20soft%20terracotta%20minimalist%20clean%20aesthetic%20subtle%20linen%20fabric%20texture%20natural%20light%20diffusion%20calming%20peaceful%20editorial%20photography%20style&width=1920&height=1080&seq=cta-warm-v4&orientation=landscape"
          alt="MuleBuy Spreadsheet background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/75"></div>
      </div>

      <div className="relative z-10 max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6">
          Start Using MuleBuy
          <br />
          Spreadsheet Today
        </h2>
        <p className="text-base md:text-lg text-background-50/70 mb-12 max-w-[560px] mx-auto leading-relaxed">
          Ready to discover trending products with the best <strong className="text-background-50/90">mulebuy spreadsheet</strong> resources? Explore curated lists and start shopping smarter.
        </p>

        <div className="inline-flex items-center gap-1">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center rounded-full bg-background-50 text-foreground-950 font-label font-bold text-sm cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap overflow-hidden"
          >
            <span className="bg-accent-500 rounded-full w-12 h-12 flex items-center justify-center -mr-1">
              <i className="ri-shopping-bag-3-line text-background-50 text-lg"></i>
            </span>
            <span className="px-6 py-3">BUY IT NOW</span>
            <span className="pr-4">
              <i className="ri-arrow-right-up-line text-foreground-600 group-hover:text-foreground-950 transition-colors"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}